import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Alert, Box, Chip, Typography } from "@mui/material";
import { formatTermSwapTimestamp, formatTermSwapWarnings } from "./termSwapNoteUtils";

const TermSwapNoteCard = ({ swap }) => {
  if (!swap) return null;

  const warnings = formatTermSwapWarnings(swap.warnings);
  const when = formatTermSwapTimestamp(swap.timestamp);

  return (
    <Box
      className="border border-app-border rounded-2xl bg-app-surface-muted p-4 max-w-xl"
      sx={{ borderLeftWidth: 4, borderLeftColor: "primary.main" }}
    >
      <Box className="flex items-center gap-2 mb-2">
        <SwapHorizIcon fontSize="small" color="primary" />
        <Chip label="Term swap" size="small" color="primary" variant="outlined" />
      </Box>

      <Typography variant="subtitle2" className="text-app-text font-semibold mb-2">
        Term T{swap.termA} ↔ Term T{swap.termB}
      </Typography>

      <Box component="dl" className="grid grid-cols-1 gap-1.5 m-0 text-sm">
        <Box className="flex gap-2">
          <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 88 }}>
            Performed by
          </Typography>
          <Typography component="dd" variant="body2" className="text-app-text m-0">
            {swap.actorName}
          </Typography>
        </Box>
        {when ? (
          <Box className="flex gap-2">
            <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 88 }}>
              When
            </Typography>
            <Typography component="dd" variant="body2" className="text-app-text m-0">
              {when}
            </Typography>
          </Box>
        ) : null}
        <Box className="flex gap-2">
          <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 88 }}>
            What changed
          </Typography>
          <Typography component="dd" variant="body2" className="text-app-text m-0">
            Term labels were exchanged. Schedule, payments, notes, commission, bonus, and claims
            stayed on their physical rows.
          </Typography>
        </Box>
      </Box>

      {warnings.length > 0 ? (
        <Alert severity="warning" icon={<WarningAmberOutlinedIcon />} sx={{ mt: 2 }}>
          {warnings.map((line) => (
            <Typography key={line} variant="body2">
              {line}
            </Typography>
          ))}
        </Alert>
      ) : null}
    </Box>
  );
};

export default TermSwapNoteCard;
